import { render, staticRenderFns } from "./discountForm.vue?vue&type=template&id=4370761a&scoped=true&lang=en&"
import script from "./discountForm.vue?vue&type=script&lang=js&"
export * from "./discountForm.vue?vue&type=script&lang=js&"
import style0 from "./discountForm.vue?vue&type=style&index=0&id=4370761a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370761a",
  null
  
)

export default component.exports